<div class="flex-center flex-column">
    <div class="color-red mb-1" style="font-size: 3rem;">
        <i class="fa fa-exclamation-circle"></i>
    </div>
    <p class="subtitle">You are not authorized to access this page</p>
</div>
